import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.request.use(async function (c) {
	c.params = { ...c.params, key: process.env.REACT_APP_API_KEY };
	return c;
}, function (error) {
	return Promise.reject(error);
});

// Jorato's CloudFront sometimes serves cached 200 responses without the
// Access-Control-Allow-Origin header, which the browser blocks as a CORS
// error. Retry once with a cache-busting param to force a cache miss, so the
// response comes fresh from the origin with proper CORS headers.
axios.interceptors.response.use(undefined, async function (error) {
	const config = error.config;
	const isTransient = !error.response || error.response.status >= 500;
	if (config && config.method === 'get' && isTransient && !config._retried) {
		config._retried = true;
		config.params = { ...config.params, _cb: Date.now() };
		return axios(config);
	}
	return Promise.reject(error);
});


export default axios;